import LetterComparator from "./LetterComparator";

const GuessDisplay = ({guess, targetWord, index}) => {

    let results = LetterComparator(guess, targetWord);
    return (
        <div className='word' key={`guess-${index}`}>
            {
                guess.split('').map((letter, i) => (
                    <div className='letterBox' state={results[i].resultState} type='result' key={`letter-${i}`}>
                        <span className='letter'>{letter}</span>
                    </div>
                ))
            }       
        </div>
    )
}


export default GuessDisplay;